"use strict";

var _interopRequireDefault = require("/root/workspace/mall_vue_JOYE/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
require("core-js/modules/es7.object.get-own-property-descriptors");
require("core-js/modules/es6.object.keys");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es6.regexp.to-string");
require("core-js/modules/es6.array.find");
var _toConsumableArray2 = _interopRequireDefault(require("/root/workspace/mall_vue_JOYE/node_modules/@babel/runtime-corejs2/helpers/toConsumableArray.js"));
require("core-js/modules/es6.set");
require("core-js/modules/es6.number.constructor");
require("core-js/modules/es6.array.find-index");
var _defineProperty2 = _interopRequireDefault(require("/root/workspace/mall_vue_JOYE/node_modules/@babel/runtime-corejs2/helpers/defineProperty.js"));
require("core-js/modules/es6.map");
require("core-js/modules/es6.regexp.split");
require("core-js/modules/es6.string.iterator");
var _slicedToArray2 = _interopRequireDefault(require("/root/workspace/mall_vue_JOYE/node_modules/@babel/runtime-corejs2/helpers/slicedToArray.js"));
require("core-js/modules/es6.array.sort");
require("core-js/modules/web.dom.iterable");
require("core-js/modules/es7.array.includes");
require("core-js/modules/es6.string.includes");
require("core-js/modules/es6.function.name");
require("core-js/modules/es6.regexp.match");
require("regenerator-runtime/runtime");
var _asyncToGenerator2 = _interopRequireDefault(require("/root/workspace/mall_vue_JOYE/node_modules/@babel/runtime-corejs2/helpers/asyncToGenerator.js"));
require("core-js/modules/es6.string.ends-with");
require("core-js/modules/es6.string.starts-with");
var _lottery = require("@/api/activity/lottery");
var _goods = require("@/api/goods/goods");
var _shopList = require("@/api/shop/shopList");
var _gradeInfo = require("@/api/basic/gradeInfo");
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; } //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
// 图片上传组件
var ImageUpload = {
  name: 'ImageUpload',
  props: {
    value: String,
    prefix: String,
    disabled: Boolean
  },
  data: function data() {
    return {
      fileList: [],
      dialogImageUrl: '',
      dialogVisible: false
    };
  },
  // 移除watch，改为在mounted中初始化，减少响应式开销
  mounted: function mounted() {
    this.updateFileList();
  },
  watch: {
    value: {
      handler: function handler(newVal) {
        this.updateFileList();
      }
    }
  },
  methods: {
    updateFileList: function updateFileList() {
      var newVal = this.value;
      if (newVal) {
        // 将相对路径转换为完整URL用于显示
        var displayUrl = newVal;
        if (!newVal.startsWith('http://') && !newVal.startsWith('https://')) {
          // 是相对路径，需要拼接前缀
          var prefix = this.prefix || '';
          var path = newVal.startsWith('/') ? newVal.slice(1) : newVal;
          displayUrl = prefix.endsWith('/') ? prefix + path : prefix + '/' + path;
        }
        this.fileList = [{
          name: 'image',
          url: displayUrl
        }];
      } else {
        this.fileList = [];
      }
    },
    handlePictureCardPreview: function handlePictureCardPreview(file) {
      // 使用相对路径拼接图片前缀
      var url = file.url;
      if (!url) return;

      // 如果是完整URL，直接使用；否则拼接前缀
      if (url.startsWith('http://') || url.startsWith('https://')) {
        this.dialogImageUrl = url;
      } else {
        // 拼接图片前缀
        var prefix = this.prefix || '';
        var path = url.startsWith('/') ? url.slice(1) : url;
        this.dialogImageUrl = prefix.endsWith('/') ? prefix + path : prefix + '/' + path;
      }
      console.log('预览URL:', this.dialogImageUrl);
      this.dialogVisible = true;
    },
    handleRemove: function handleRemove(file, fileList) {
      this.fileList = fileList;
      this.$emit('input', '');
    },
    handleChange: function handleChange(file, fileList) {
      if (fileList.length > 0) {
        var isValid = this.beforeUpload(file.raw);
        if (isValid) {
          this.uploadImage(file.raw);
        }
      }
    },
    beforeUpload: function beforeUpload(file) {
      var isImage = file.type.startsWith('image/');
      var isLt2M = file.size / 1024 / 1024 < 2;
      if (!isImage) {
        this.$message.error('只能上传图片文件！');
        return false;
      }
      if (!isLt2M) {
        this.$message.error('图片大小不能超过2MB！');
        return false;
      }
      return true;
    },
    uploadImage: function () {
      var _uploadImage = (0, _asyncToGenerator2.default)(/*#__PURE__*/regeneratorRuntime.mark(function _callee(file) {
        var loading, res, url, relativePath, urlObj, matches, _t;
        return regeneratorRuntime.wrap(function (_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              loading = this.$loading({
                lock: true,
                text: '上传中...',
                spinner: 'el-icon-loading',
                background: 'rgba(0, 0, 0, 0.7)'
              });
              _context.prev = 1;
              _context.next = 2;
              return (0, _lottery.uploadLotteryImage)(file);
            case 2:
              res = _context.sent;
              loading.close();
              // 兼容不同的返回格式：res.data 或者直接 res
              url = res && res.data || res;
              if (url) {
                // 将完整 URL 转换为相对路径
                relativePath = url;
                if (url.startsWith('http://') || url.startsWith('https://')) {
                  try {
                    urlObj = new URL(url);
                    relativePath = urlObj.pathname;
                  } catch (e) {
                    // 如果 URL 解析失败，尝试手动提取路径
                    matches = url.match(/https?:\/\/[^/]+(.+)/);
                    if (matches && matches[1]) {
                      relativePath = matches[1];
                    }
                  }
                }
                this.fileList = [{
                  name: file.name,
                  url: relativePath
                }];
                this.$emit('input', relativePath);
                this.$message.success('上传成功');
              } else {
                this.$message.error('上传失败');
              }
              _context.next = 4;
              break;
            case 3:
              _context.prev = 3;
              _t = _context["catch"](1);
              loading.close();
              this.$message.error('上传失败：' + _t.message);
            case 4:
            case "end":
              return _context.stop();
          }
        }, _callee, this, [[1, 3]]);
      }));
      function uploadImage(_x) {
        return _uploadImage.apply(this, arguments);
      }
      return uploadImage;
    }()
  },
  render: function render(h) {
    var _this = this;
    var classes = ['image-upload-container'];
    if (this.disabled) {
      classes.push('is-disabled');
    }
    return h('div', {
      class: classes,
      attrs: {
        'data-has-file': this.fileList.length > 0 ? 'true' : 'false'
      }
    }, [h('el-upload', {
      props: {
        action: '#',
        'list-type': 'picture-card',
        'file-list': this.fileList,
        limit: 1,
        disabled: this.disabled,
        'on-preview': this.handlePictureCardPreview,
        'on-remove': this.handleRemove,
        'on-change': this.handleChange,
        'before-upload': this.beforeUpload
      }
    }, [h('i', {
      class: 'el-icon-plus',
      slot: 'default'
    })]), h('el-dialog', {
      props: {
        visible: this.dialogVisible,
        title: '图片预览',
        center: true
      },
      on: {
        'update:visible': function updateVisible(val) {
          _this.dialogVisible = val;
        }
      }
    }, [h('img', {
      attrs: {
        src: this.dialogImageUrl
      },
      style: {
        width: '100%',
        display: 'block'
      }
    })])]);
  }
};
var _default2 = exports.default = {
  name: 'LotteryConfigPane',
  components: {
    ImageUpload: ImageUpload
  },
  props: {
    id: {
      // 允许Number或null
      validator: function validator(value) {
        return value === null || typeof value === 'number';
      },
      default: null
    },
    sharedData: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  },
  data: function data() {
    return {
      activeTab: 'theme',
      loading: false,
      submitLoading: false,
      imagePrefix: '',
      bonusList: [],
      dateRange: [],
      userRankOptions: [],
      userRankList: [],
      loadedIds: [],
      // 记录已经加载过的活动ID
      limitEnabled: {
        totalNum: true,
        preMaxNum: true,
        preDayMaxNum: true
      },
      conditionEnabled: {
        preDayGive: true,
        conditionConsume: true,
        conditionInvite: true,
        inviteGiveTimes: true,
        goods: false,
        category: false,
        weworkGiveTimes: true
      },
      selectedGoodsList: [],
      selectedCategoryList: [],
      tempCategoryList: [],
      categoryOptions: [],
      goodsSelectorVisible: false,
      goodsListQuery: {
        keywords: '',
        categories: [],
        goodsType: '',
        status: '1',
        page: 1,
        limit: 10
      },
      goodsListData: [],
      goodsListTotal: 0,
      tempSelectedGoods: [],
      categorySelectorVisible: false,
      // 门店选择相关
      storeSelectorVisible: false,
      storeSearchText: '',
      storeTreeData: [],
      storeTreeProps: {
        children: 'children',
        label: 'label'
      },
      storeExpandedKeys: [],
      storeCheckedKeys: [],
      selectedStoreList: [],
      isStoreTreeInitializing: false,
      formData: {
        title: '',
        shareTitle: '',
        bannerUrl: '',
        bgUrl: '',
        shareImgUrl: '',
        theme: {
          fgColor: '#98CAC1',
          bgColor: '#1A4D38',
          btnColor: '#FF6B6B',
          btnGradientColor: '#FF8E8E',
          btnTextColor: '#FFFFFF'
        },
        pos: 1,
        enabled: 1,
        showOrder: 0,
        startTime: '',
        endTime: '',
        userType: 0,
        userRank: '',
        dailyReset: 0,
        isQwe: 0,
        orderReal: 0,
        totalNum: 0,
        preMaxNum: 0,
        preDayMaxNum: 0,
        preDayGive: 0,
        conditionConsume: 0,
        conditionInvite: 0,
        inviteGiveTimes: 0,
        orderScenes: [1, 2, 3],
        weworkGiveTimes: 0,
        isCondition: 0,
        point: 0,
        rule: '',
        pack: []
      },
      formRules: {
        title: [{
          required: true,
          message: '请输入活动标题',
          trigger: 'blur'
        }]
      }
    };
  },
  computed: {
    // 移除性能敏感的computed，改为methods
    totalRate: function totalRate() {
      if (!this.formData.pack || !Array.isArray(this.formData.pack) || this.formData.pack.length === 0) {
        return '0.00';
      }
      // 简单计算，不递归
      var sum = 0;
      for (var i = 0; i < this.formData.pack.length; i++) {
        sum += parseFloat(this.formData.pack[i].rate) || 0;
      }
      return sum.toFixed(2);
    },
    // 判断用户级别是否全选
    isAllUserRanksSelected: function isAllUserRanksSelected() {
      var _this2 = this;
      if (!this.userRankOptions || this.userRankOptions.length === 0) return false;
      return this.userRankOptions.length > 0 && this.userRankOptions.every(function (rank) {
        return _this2.userRankList.includes(rank.id);
      });
    },
    // 判断门店是否全选 - 简化版，不递归计算
    isAllStoresSelected: function isAllStoresSelected() {
      if (!this.storeTreeData || this.storeTreeData.length === 0) {
        return false;
      }
      // 获取所有叶子节点（门店）的数量
      var _getAllLeafCount = function getAllLeafCount(nodes) {
        var count = 0;
        nodes.forEach(function (node) {
          if (node.children && node.children.length > 0) {
            count += _getAllLeafCount(node.children);
          } else {
            count++;
          }
        });
        return count;
      };
      var totalLeafCount = _getAllLeafCount(this.storeTreeData);
      // 如果选中的数量等于或大于叶子节点总数，认为全选
      return this.storeCheckedKeys.length >= totalLeafCount && totalLeafCount > 0;
    },
    // 判断订单场景是否全选
    isAllOrderScenesSelected: function isAllOrderScenesSelected() {
      var _this3 = this;
      return [1, 2, 3].every(function (scene) {
        return _this3.formData.orderScenes.includes(scene);
      });
    },
    // 预计算所有奖项的最高中奖率，避免在模板中调用方法导致性能问题
    maxRates: function maxRates() {
      if (!this.formData.pack || !Array.isArray(this.formData.pack)) {
        return [];
      }
      // 一次性计算所有奖项的maxRate
      var maxRates = [];
      for (var i = 0; i < this.formData.pack.length; i++) {
        var usedRate = 0;
        for (var j = 0; j < this.formData.pack.length; j++) {
          if (j !== i) {
            usedRate += parseFloat(this.formData.pack[j].rate) || 0;
          }
        }
        var maxRate = Math.max(0, 100 - usedRate);
        maxRates.push(parseFloat(maxRate.toFixed(2)));
      }
      return maxRates;
    },
    flatCategoryList: function flatCategoryList() {
      var _this4 = this;
      // 将选中的小类ID列表转换为分类对象列表，用于显示
      if (!this.selectedCategoryList || this.selectedCategoryList.length === 0) return [];

      // 如果categoryOptions还没加载完成，返回空数组
      if (!this.categoryOptions || this.categoryOptions.length === 0) return [];

      // 缓存优化：如果selectedCategoryList没变，不重新计算
      var cacheKey = this.selectedCategoryList.sort().join(',');
      if (this._flatCategoryListCache && this._flatCategoryListCache.key === cacheKey) {
        return this._flatCategoryListCache.list;
      }
      var list = [];
      // 递归查找所有选中的叶子节点（小类）
      var _findSelectedLeaves = function findSelectedLeaves(nodes) {
        if (!nodes || !Array.isArray(nodes)) return;
        for (var i = 0; i < nodes.length; i++) {
          var node = nodes[i];
          // 跳过null节点
          if (!node) continue;

          // 如果是叶子节点（没有children）且被选中
          if (!node.children || node.children.length === 0) {
            if (_this4.selectedCategoryList.includes(node.id)) {
              list.push({
                id: node.id,
                label: node.label
              });
            }
          } else {
            // 如果有子节点，递归查找
            _findSelectedLeaves(node.children);
          }
        }
      };
      _findSelectedLeaves(this.categoryOptions);

      // 缓存结果
      this._flatCategoryListCache = {
        key: cacheKey,
        list: list
      };
      return list;
    }
  },
  watch: {
    storeSearchText: function storeSearchText(val) {
      this.$refs.storeTreeDialog && this.$refs.storeTreeDialog.filter(val);
    }
  },
  created: function () {
    var _created = (0, _asyncToGenerator2.default)(/*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
      var hasSharedData;
      return regeneratorRuntime.wrap(function (_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            // 检查sharedData中是否已有通用数据，任何一个为空都需要重新加载
            hasSharedData = this.sharedData && this.sharedData.imagePrefix && this.sharedData.bonusList && Array.isArray(this.sharedData.bonusList) && this.sharedData.bonusList.length > 0 && this.sharedData.categoryTree && Array.isArray(this.sharedData.categoryTree) && this.sharedData.categoryTree.length > 0 && this.sharedData.storeTree && Array.isArray(this.sharedData.storeTree) && this.sharedData.storeTree.length > 0;
            if (!hasSharedData) {
              _context2.next = 2;
              break;
            }
            // 使用缓存数据，直接从sharedData赋值
            this.imagePrefix = this.sharedData.imagePrefix;
            this.bonusList = this.sharedData.bonusList;
            this.categoryOptions = this.sharedData.categoryTree;
            this.storeTreeData = this.sharedData.storeTree;
            // 加载用户级别列表
            _context2.next = 1;
            return this.loadUserRankList();
          case 1:
            _context2.next = 3;
            break;
          case 2:
            _context2.next = 3;
            return this.loadSharedData();
          case 3:
            // 新增模式下才初始化奖项包
            if (!this.id) {
              this.initAwardPack();
              // 新增模式下，默认全选用户级别
              this.userRankList = this.userRankOptions.map(function (rank) {
                return rank.id;
              });
            }
            if (!this.id) {
              _context2.next = 5;
              break;
            }
            if (!(this.sharedData && this.sharedData.activityDetails && this.sharedData.activityDetails[this.id])) {
              _context2.next = 4;
              break;
            }
            // 使用缓存数据
            console.log('使用活动详情缓存，id:', this.id);
            this.loadFormDataFromCache();
            _context2.next = 5;
            break;
          case 4:
            // 第一次打开这个活动，从后端获取
            console.log('从后端获取活动详情，id:', this.id);
            this.loading = true;
            _context2.next = 5;
            return this.loadFormData();
          case 5:
          case "end":
            return _context2.stop();
        }
      }, _callee2, this);
    }));
    function created() {
      return _created.apply(this, arguments);
    }
    return created;
  }(),
  methods: {
    // 加载共享数据到sharedData
    loadSharedData: function () {
      var _loadSharedData = (0, _asyncToGenerator2.default)(/*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
        var _yield$Promise$all, _yield$Promise$all2, imagePrefix, bonusList, categoryTree, storeTree, _t2;
        return regeneratorRuntime.wrap(function (_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              _context3.prev = 0;
              _context3.next = 1;
              return Promise.all([this.getImagePrefix(), this.getBonusList(), this.getCategoryTree(), this.getStoreTree()]);
            case 1:
              _yield$Promise$all = _context3.sent;
              _yield$Promise$all2 = (0, _slicedToArray2.default)(_yield$Promise$all, 4);
              imagePrefix = _yield$Promise$all2[0];
              bonusList = _yield$Promise$all2[1];
              categoryTree = _yield$Promise$all2[2];
              storeTree = _yield$Promise$all2[3];
              // 存入sharedData
              if (this.sharedData) {
                this.sharedData.imagePrefix = imagePrefix;
                this.sharedData.bonusList = bonusList;
                this.sharedData.categoryTree = categoryTree;
                this.sharedData.storeTree = storeTree;
              }

              // 赋值给当前组件
              this.imagePrefix = imagePrefix;
              this.bonusList = bonusList;
              this.categoryOptions = categoryTree;
              this.storeTreeData = storeTree;

              // 加载用户级别列表
              _context3.next = 2;
              return this.loadUserRankList();
            case 2:
              _context3.next = 4;
              break;
            case 3:
              _context3.prev = 3;
              _t2 = _context3["catch"](0);
              console.error('加载共享数据失败:', _t2);
            case 4:
            case "end":
              return _context3.stop();
          }
        }, _callee3, this, [[0, 3]]);
      }));
      function loadSharedData() {
        return _loadSharedData.apply(this, arguments);
      }
      return loadSharedData;
    }(),
    // 获取图片前缀
    getImagePrefix: function getImagePrefix() {
      return process.env.VUE_APP_IMAGE_PATH || '';
    },
    // 获取优惠券列表
    getBonusList: function () {
      var _getBonusList2 = (0, _asyncToGenerator2.default)(/*#__PURE__*/regeneratorRuntime.mark(function _callee4() {
        var response, _t3;
        return regeneratorRuntime.wrap(function (_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              _context4.prev = 0;
              _context4.next = 1;
              return (0, _lottery.getBonusList)();
            case 1:
              response = _context4.sent;
              return _context4.abrupt("return", response && response.code === 200 && response.data ? response.data : []);
            case 2:
              _context4.prev = 2;
              _t3 = _context4["catch"](0);
              console.error('获取优惠券列表失败:', _t3);
              return _context4.abrupt("return", []);
            case 3:
            case "end":
              return _context4.stop();
          }
        }, _callee4, null, [[0, 2]]);
      }));
      function getBonusList() {
        return _getBonusList2.apply(this, arguments);
      }
      return getBonusList;
    }(),
    // 获取用户级别列表
    loadUserRankList: function () {
      var _loadUserRankList = (0, _asyncToGenerator2.default)(/*#__PURE__*/regeneratorRuntime.mark(function _callee5() {
        var response, _t4;
        return regeneratorRuntime.wrap(function (_context5) {
          while (1) switch (_context5.prev = _context5.next) {
            case 0:
              _context5.prev = 0;
              _context5.next = 1;
              return (0, _gradeInfo.xyRuleVipGradeSelPage)({
                page: 1,
                limit: 100
              });
            case 1:
              response = _context5.sent;
              if (response.code === 200 && response.records) {
                this.userRankOptions = response.records.map(function (item) {
                  return {
                    id: item.id,
                    name: item.name
                  };
                });
              } else {
                console.error('获取用户级别列表失败:', response.message);
              }
              _context5.next = 3;
              break;
            case 2:
              _context5.prev = 2;
              _t4 = _context5["catch"](0);
              console.error('获取用户级别列表失败:', _t4);
            case 3:
            case "end":
              return _context5.stop();
          }
        }, _callee5, this, [[0, 2]]);
      }));
      function loadUserRankList() {
        return _loadUserRankList.apply(this, arguments);
      }
      return loadUserRankList;
    }(),
    // 获取分类树
    getCategoryTree: function () {
      var _getCategoryTree2 = (0, _asyncToGenerator2.default)(/*#__PURE__*/regeneratorRuntime.mark(function _callee6() {
        var response, treeData, _t5;
        return regeneratorRuntime.wrap(function (_context6) {
          while (1) switch (_context6.prev = _context6.next) {
            case 0:
              _context6.prev = 0;
              _context6.next = 1;
              return (0, _goods.getCategoryTree)();
            case 1:
              response = _context6.sent;
              treeData = null;
              if (response && response.data) {
                treeData = response.data;
              } else if (Array.isArray(response)) {
                treeData = response;
              }
              if (!treeData) {
                _context6.next = 2;
                break;
              }
              return _context6.abrupt("return", this.processCategoryTree(treeData));
            case 2:
              return _context6.abrupt("return", []);
            case 3:
              _context6.prev = 3;
              _t5 = _context6["catch"](0);
              console.error('获取分类树失败:', _t5);
              return _context6.abrupt("return", []);
            case 4:
            case "end":
              return _context6.stop();
          }
        }, _callee6, this, [[0, 3]]);
      }));
      function getCategoryTree() {
        return _getCategoryTree2.apply(this, arguments);
      }
      return getCategoryTree;
    }(),
    // 获取门店树
    getStoreTree: function () {
      var _getStoreTree = (0, _asyncToGenerator2.default)(/*#__PURE__*/regeneratorRuntime.mark(function _callee7() {
        var response, _t6;
        return regeneratorRuntime.wrap(function (_context7) {
          while (1) switch (_context7.prev = _context7.next) {
            case 0:
              _context7.prev = 0;
              _context7.next = 1;
              return (0, _shopList.queryStore)({});
            case 1:
              response = _context7.sent;
              return _context7.abrupt("return", response && response.data ? response.data : []);
            case 2:
              _context7.prev = 2;
              _t6 = _context7["catch"](0);
              console.error('获取门店树失败:', _t6);
              return _context7.abrupt("return", []);
            case 3:
            case "end":
              return _context7.stop();
          }
        }, _callee7, null, [[0, 2]]);
      }));
      function getStoreTree() {
        return _getStoreTree.apply(this, arguments);
      }
      return getStoreTree;
    }(),
    // 从缓存加载活动数据
    loadFormDataFromCache: function loadFormDataFromCache() {
      if (!this.sharedData || !this.sharedData.activityDetails || !this.sharedData.activityDetails[this.id]) {
        return;
      }
      var cachedData = this.sharedData.activityDetails[this.id];
      console.log('从缓存加载活动数据，资源配置:', cachedData._cachedResources);

      // 如果缓存中有资源配置，先设置资源，避免applyFormData触发重新加载
      if (cachedData._cachedResources) {
        var _cachedData$_cachedRe = cachedData._cachedResources,
          selectedGoodsList = _cachedData$_cachedRe.selectedGoodsList,
          selectedStoreList = _cachedData$_cachedRe.selectedStoreList;
        if (selectedGoodsList && Array.isArray(selectedGoodsList)) {
          this.selectedGoodsList = selectedGoodsList;
        }
        if (selectedStoreList && Array.isArray(selectedStoreList)) {
          this.selectedStoreList = selectedStoreList;
        }
      }

      // 应用基本数据（因为资源已经设置好了，不会触发重新加载）
      this.applyFormData(cachedData);
    },
    // 应用表单数据（从接口或缓存）
    applyFormData: function applyFormData(data) {
      var _this5 = this;
      console.log('应用表单数据:', data);

      // 转换图片 URL 为相对路径
      var convertToRelativePath = function convertToRelativePath(url) {
        if (!url || typeof url !== 'string') return url;
        if (url.startsWith('http://') || url.startsWith('https://')) {
          try {
            var urlObj = new URL(url);
            return urlObj.pathname;
          } catch (e) {
            // 如果 URL 解析失败，尝试手动提取路径
            var matches = url.match(/https?:\/\/[^/]+(.+)/);
            if (matches && matches[1]) {
              return matches[1];
            }
          }
        }
        return url;
      };

      // 处理时间范围
      if (data.startTime && data.endTime) {
        this.dateRange = [data.startTime, data.endTime];
      }

      // 处理用户级别
      if (data.userRank) {
        if (typeof data.userRank === 'string') {
          this.userRankList = data.userRank.split(',').map(function (item) {
            return parseInt(item.trim());
          }).filter(function (num) {
            return !isNaN(num);
          });
        } else if (Array.isArray(data.userRank)) {
          this.userRankList = data.userRank;
        }
      } else {
        this.userRankList = [1, 2, 3, 4, 5];
      }

      // 处理主题
      if (typeof data.theme === 'string') {
        try {
          data.theme = JSON.parse(data.theme);
        } catch (e) {
          data.theme = {
            fgColor: '#98CAC1',
            bgColor: '#1A4D38',
            btnColor: '#FF6B6B',
            btnGradientColor: '#FF8E8E',
            btnTextColor: '#FFFFFF'
          };
        }
      }

      // 确保主题包含所有必需字段
      if (!data.theme.btnColor) {
        data.theme.btnColor = '#FF6B6B';
      }
      if (!data.theme.btnGradientColor) {
        data.theme.btnGradientColor = '#FF8E8E';
      }
      if (!data.theme.btnTextColor) {
        data.theme.btnTextColor = '#FFFFFF';
      }

      // 处理位置
      if (typeof data.pos === 'string') {
        data.pos = data.pos ? parseInt(data.pos) : 1;
      }

      // 解析奖品配置
      if (data.pack) {
        try {
          if (typeof data.pack === 'string') {
            data.pack = JSON.parse(data.pack);
          }
          if (!Array.isArray(data.pack) || data.pack.length === 0) {
            delete data.pack;
          } else {
            // 确保有8个元素
            while (data.pack.length < 8) {
              data.pack.push({
                enabled: true,
                awardType: 0,
                rate: 0,
                total: 0,
                num: 1,
                typeId: null,
                imgUrl: '',
                iconUrl: '',
                hitTimes: 0
              });
            }
          }
        } catch (e) {
          console.error('解析奖品配置失败:', e);
          delete data.pack;
        }
      }

      // 解析门店ID列表
      if (data.storeIds) {
        try {
          data.storeIds = typeof data.storeIds === 'string' ? JSON.parse(data.storeIds) : data.storeIds;
          if (!Array.isArray(data.storeIds)) {
            data.storeIds = [];
          }
        } catch (e) {
          console.error('解析门店ID列表失败:', e);
          data.storeIds = [];
        }
      }

      // 解析商品ID列表
      if (data.goodsIds) {
        try {
          data.goodsIds = typeof data.goodsIds === 'string' ? JSON.parse(data.goodsIds) : data.goodsIds;
          if (!Array.isArray(data.goodsIds)) {
            data.goodsIds = [];
          }
        } catch (e) {
          console.error('解析商品ID列表失败:', e);
          data.goodsIds = [];
        }
      }

      // 解析分类ID列表
      if (data.categoryIds) {
        try {
          data.categoryIds = typeof data.categoryIds === 'string' ? JSON.parse(data.categoryIds) : data.categoryIds;
          if (!Array.isArray(data.categoryIds)) {
            data.categoryIds = [];
          }
        } catch (e) {
          console.error('解析分类ID列表失败:', e);
          data.categoryIds = [];
        }
      }

      // 解析订单场景
      if (data.orderScenes) {
        try {
          data.orderScenes = typeof data.orderScenes === 'string' ? JSON.parse(data.orderScenes) : data.orderScenes;
          if (!Array.isArray(data.orderScenes) || data.orderScenes.length === 0) {
            data.orderScenes = [1, 2, 3];
          }
        } catch (e) {
          console.error('解析订单场景失败:', e);
          data.orderScenes = [1, 2, 3];
        }
      }
      var storeIds = data.storeIds;
      var goodsIds = data.goodsIds;
      var categoryIds = data.categoryIds;
      var orderScenes = data.orderScenes;
      delete data.storeIds;
      delete data.goodsIds;
      delete data.categoryIds;
      delete data.orderScenes;

      // 处理 hitTimes 字符串，解析为数组
      var hitTimesArray = [];
      if (data.hitTimes && typeof data.hitTimes === 'string') {
        hitTimesArray = data.hitTimes.split(',').map(function (item) {
          return parseInt(item.trim()) || 0;
        });
      } else if (data.hit_times && typeof data.hit_times === 'string') {
        hitTimesArray = data.hit_times.split(',').map(function (item) {
          return parseInt(item.trim()) || 0;
        });
      }
      // 确保 hitTimesArray 有8个元素
      while (hitTimesArray.length < 8) {
        hitTimesArray.push(0);
      }

      // 处理奖项包
      if (data.pack && Array.isArray(data.pack)) {
        while (this.formData.pack.length < 8) {
          this.formData.pack.push({
            enabled: true,
            awardType: 0,
            rate: 0,
            total: 0,
            num: 1,
            typeId: null,
            imgUrl: '',
            iconUrl: '',
            hitTimes: 0
          });
        }
        for (var i = 0; i < 8; i++) {
          if (data.pack[i]) {
            var sourceItem = data.pack[i];
            var targetItem = this.formData.pack[i];
            targetItem.enabled = sourceItem.enabled !== undefined ? sourceItem.enabled : true;
            targetItem.awardType = sourceItem.awardType !== undefined ? sourceItem.awardType : 0;
            targetItem.rate = sourceItem.rate !== undefined ? sourceItem.rate : 0;
            targetItem.total = sourceItem.total !== undefined ? sourceItem.total : 0;
            targetItem.num = sourceItem.num !== undefined ? sourceItem.num : 1;
            targetItem.typeId = sourceItem.typeId !== undefined ? sourceItem.typeId : null;
            targetItem.imgUrl = convertToRelativePath(sourceItem.imgUrl || '');
            targetItem.iconUrl = convertToRelativePath(sourceItem.iconUrl || '');
            // 使用解析后的 hitTimes 数组
            targetItem.hitTimes = hitTimesArray[i] !== undefined ? hitTimesArray[i] : 0;
          }
        }
        delete data.pack;
      } else {
        this.initAwardPack();
        delete data.pack;
      }

      // 转换图片 URL 为相对路径
      if (data.bgUrl) data.bgUrl = convertToRelativePath(data.bgUrl);
      if (data.bannerUrl) data.bannerUrl = convertToRelativePath(data.bannerUrl);
      if (data.shareImgUrl) data.shareImgUrl = convertToRelativePath(data.shareImgUrl);
      Object.assign(this.formData, data);

      // 处理消费金额最大次数，如果后端没有返回则默认为0
      if (this.formData.consumeMaxTimes === undefined || this.formData.consumeMaxTimes === null) {
        this.formData.consumeMaxTimes = 0;
      }

      // 处理订单是否实付，如果后端没有返回则默认为0
      if (this.formData.orderReal === undefined || this.formData.orderReal === null) {
        this.formData.orderReal = 0;
      }
      this.limitEnabled.totalNum = data.totalNum !== -1;
      this.limitEnabled.preMaxNum = data.preMaxNum !== -1;
      this.limitEnabled.preDayMaxNum = data.preDayMaxNum !== -1;
      this.conditionEnabled.preDayGive = data.preDayGive !== -1;
      this.conditionEnabled.conditionConsume = data.conditionConsume !== -1;
      this.conditionEnabled.conditionInvite = data.conditionInvite !== -1;
      this.conditionEnabled.inviteGiveTimes = data.inviteGiveTimes !== -1;
      this.formData.orderScenes = orderScenes && Array.isArray(orderScenes) && orderScenes.length > 0 ? orderScenes : [1, 2, 3];
      this.conditionEnabled.weworkGiveTimes = data.weworkGiveTimes !== -1;
      this.conditionEnabled.goods = !!(goodsIds && Array.isArray(goodsIds) && goodsIds.length > 0);
      this.conditionEnabled.category = !!(categoryIds && Array.isArray(categoryIds) && categoryIds.length > 0);
      this.selectedCategoryList = categoryIds && Array.isArray(categoryIds) ? categoryIds : [];
      if (storeIds && Array.isArray(storeIds) && storeIds.length > 0) {
        this.storeCheckedKeys = storeIds;
        this.$nextTick(function () {
          if (_this5.storeTreeData && _this5.storeTreeData.length > 0) {
            _this5.loadSelectedStoreInfo();
          }
        });
      } else {
        this.storeCheckedKeys = [];
        this.selectedStoreList = [];
      }
      if (goodsIds && Array.isArray(goodsIds) && goodsIds.length > 0) {
        // 如果selectedGoodsList已经有值（从缓存加载的），就不重新加载
        if (this.selectedGoodsList && this.selectedGoodsList.length > 0) {
          console.log('使用缓存商品列表，数量:', this.selectedGoodsList.length);
        } else {
          this.$nextTick(function () {
            _this5.loadGoodsByIds(goodsIds);
          });
        }
      } else {
        this.selectedGoodsList = [];
      }
    },
    // 加载门店树数据
    loadStoreTreeData: function () {
      var _loadStoreTreeData = (0, _asyncToGenerator2.default)(/*#__PURE__*/regeneratorRuntime.mark(function _callee8() {
        var response, _t7;
        return regeneratorRuntime.wrap(function (_context8) {
          while (1) switch (_context8.prev = _context8.next) {
            case 0:
              _context8.prev = 0;
              _context8.next = 1;
              return (0, _shopList.queryStore)({});
            case 1:
              response = _context8.sent;
              if (response && response.data) {
                this.storeTreeData = response.data;
                // 默认展开第一层和第二层
                this.storeExpandedKeys = [1, 2];
              }
              _context8.next = 3;
              break;
            case 2:
              _context8.prev = 2;
              _t7 = _context8["catch"](0);
              console.error('获取门店树数据失败:', _t7);
            case 3:
            case "end":
              return _context8.stop();
          }
        }, _callee8, this, [[0, 2]]);
      }));
      function loadStoreTreeData() {
        return _loadStoreTreeData.apply(this, arguments);
      }
      return loadStoreTreeData;
    }(),
    // 处理门店选择变化
    handleStoreCheck: function handleStoreCheck(data, checked) {
      var _this6 = this;
      // 如果正在初始化，跳过处理
      if (this.isStoreTreeInitializing) return;
      if (checked) {
        // 拦截非叶子节点选择
        if (data.children && data.children.length > 0) {
          // 获取data.children的所有id
          data.children.forEach(function (item) {
            if (!_this6.storeCheckedKeys.includes(item.id)) {
              _this6.storeCheckedKeys.push(item.id);
              // 添加到已选择门店列表
              if (!_this6.selectedStoreList.some(function (store) {
                return store.id === item.id;
              })) {
                _this6.selectedStoreList.push({
                  id: item.id,
                  storeName: item.label,
                  storeAddress: item.address || ''
                });
              }
            }
          });
        } else {
          // 直接检查数组是否包含该元素
          if (!this.storeCheckedKeys.includes(data.id)) {
            this.storeCheckedKeys.push(data.id);
            // 添加到已选择门店列表
            if (!this.selectedStoreList.some(function (store) {
              return store.id === data.id;
            })) {
              this.selectedStoreList.push({
                id: data.id,
                storeName: data.label,
                storeAddress: data.address || ''
              });
            }
          }
        }
      } else {
        // 如果是父节点，需要移除其所有子节点
        if (data.children && data.children.length > 0) {
          // 获取data.children的所有id
          data.children.forEach(function (item) {
            _this6.storeCheckedKeys = _this6.storeCheckedKeys.filter(function (id) {
              return id !== item.id;
            });
            _this6.selectedStoreList = _this6.selectedStoreList.filter(function (store) {
              return store.id !== item.id;
            });
          });
        } else {
          // 直接移除当前节点
          this.storeCheckedKeys = this.storeCheckedKeys.filter(function (id) {
            return id !== data.id;
          });
          this.selectedStoreList = this.selectedStoreList.filter(function (store) {
            return store.id !== data.id;
          });
        }
      }
    },
    // 全选/取消全选门店
    selectAllStores: function selectAllStores() {
      var _this7 = this;
      // 设置操作标志，避免触发handleStoreCheckInDialog
      this.isStoreTreeInitializing = true;

      // 获取所有叶子节点的key（id用于el-tree，storeId用于存储）
      var _getAllLeafKeys = function getAllLeafKeys(nodes) {
        var keys = {
          ids: [],
          storeIds: []
        };
        nodes.forEach(function (node) {
          if (node.children && node.children.length > 0) {
            var childKeys = _getAllLeafKeys(node.children);
            keys.ids = keys.ids.concat(childKeys.ids);
            keys.storeIds = keys.storeIds.concat(childKeys.storeIds);
          } else {
            keys.ids.push(node.id);
            keys.storeIds.push(node.storeId);
          }
        });
        return keys;
      };
      var allLeafKeys = _getAllLeafKeys(this.storeTreeData);

      // 检查当前是否已经全选
      if (this.isAllStoresSelected) {
        // 如果已经全选，则取消全选
        if (this.$refs.storeTreeDialog) {
          this.$refs.storeTreeDialog.setCheckedKeys([]);
        }
        this.storeCheckedKeys = [];
        this.selectedStoreList = [];
      } else {
        // 如果未全选，则全选
        if (this.$refs.storeTreeDialog) {
          this.$refs.storeTreeDialog.setCheckedKeys(allLeafKeys.ids);
        }

        // 获取所有叶子节点（门店）信息
        var _getAllLeafNodes = function getAllLeafNodes(nodes) {
          var leafNodes = [];
          nodes.forEach(function (node) {
            if (node.children && node.children.length > 0) {
              leafNodes = leafNodes.concat(_getAllLeafNodes(node.children));
            } else {
              leafNodes.push({
                id: node.storeId,
                storeName: node.label,
                storeAddress: node.address || ''
              });
            }
          });
          return leafNodes;
        };

        // 更新选中的门店 - 使用 storeId
        this.storeCheckedKeys = allLeafKeys.storeIds;
        this.selectedStoreList = _getAllLeafNodes(this.storeTreeData);
      }

      // 操作完成后，取消操作标志
      this.$nextTick(function () {
        _this7.isStoreTreeInitializing = false;
      });
    },
    // 过滤门店节点
    filterStoreNode: function filterStoreNode(value, data) {
      if (!value) return true;
      return data.label.indexOf(value) !== -1;
    },
    // 辅助方法：将 storeId 数组转换为对应的 id 数组（用于 el-tree 的 setCheckedKeys）
    convertStoreIdsToTreeKeys: function convertStoreIdsToTreeKeys(storeIds) {
      if (!storeIds || !Array.isArray(storeIds) || storeIds.length === 0) {
        return [];
      }
      var idMap = new Map();
      var _buildMap = function buildMap(nodes) {
        nodes.forEach(function (node) {
          if (node.children && node.children.length > 0) {
            _buildMap(node.children);
          } else if (node.storeId !== undefined) {
            idMap.set(node.storeId, node.id);
          }
        });
      };
      _buildMap(this.storeTreeData);
      return storeIds.map(function (storeId) {
        return idMap.get(storeId);
      }).filter(function (id) {
        return id !== undefined;
      });
    },
    // 辅助方法：将 id 数组转换为对应的 storeId 数组
    convertTreeKeysToStoreIds: function convertTreeKeysToStoreIds(ids) {
      if (!ids || !Array.isArray(ids) || ids.length === 0) {
        return [];
      }
      var storeIdMap = new Map();
      var _buildMap2 = function buildMap(nodes) {
        nodes.forEach(function (node) {
          if (node.children && node.children.length > 0) {
            _buildMap2(node.children);
          } else if (node.storeId !== undefined) {
            storeIdMap.set(node.id, node.storeId);
          }
        });
      };
      _buildMap2(this.storeTreeData);
      return ids.map(function (id) {
        return storeIdMap.get(id);
      }).filter(function (storeId) {
        return storeId !== undefined;
      });
    },
    // 打开门店选择器对话框
    openStoreSelector: function openStoreSelector() {
      var _this8 = this;
      this.storeSelectorVisible = true;
      // 确保对话框中的树已经渲染
      this.$nextTick(function () {
        if (_this8.$refs.storeTreeDialog) {
          _this8.isStoreTreeInitializing = true;
          // 将 storeId 转换为 id 后设置选中状态
          var treeKeys = _this8.convertStoreIdsToTreeKeys(_this8.storeCheckedKeys);
          _this8.$refs.storeTreeDialog.setCheckedKeys(treeKeys);
          _this8.$nextTick(function () {
            _this8.isStoreTreeInitializing = false;
          });
        }
      });
    },
    // 确认门店选择
    confirmStoreSelection: function confirmStoreSelection() {
      this.storeSelectorVisible = false;
      // 已在 handleStoreCheckInDialog 中实时更新，这里只需关闭对话框
    },
    // 移除已选择的门店
    removeStore: function removeStore(storeId) {
      // 从选中的key列表中移除
      this.storeCheckedKeys = this.storeCheckedKeys.filter(function (id) {
        return id !== storeId;
      });
      // 从已选列表中移除
      this.selectedStoreList = this.selectedStoreList.filter(function (store) {
        return store.id !== storeId;
      });
    },
    // 对话框中的门店选择处理
    handleStoreCheckInDialog: function handleStoreCheckInDialog() {
      // 如果正在初始化，跳过处理
      if (this.isStoreTreeInitializing) return;

      // 使用 getCheckedNodes 直接获取所有选中的节点，避免手动维护状态导致的问题
      if (this.$refs.storeTreeDialog) {
        var checkedNodes = this.$refs.storeTreeDialog.getCheckedNodes(true); // true 表示只获取叶子节点

        // 更新选中的key列表 - 使用 storeId 而不是 id
        this.storeCheckedKeys = checkedNodes.map(function (node) {
          return node.storeId;
        });

        // 更新已选择门店列表（只包含叶子节点，即门店）
        this.selectedStoreList = checkedNodes.map(function (node) {
          return {
            id: node.storeId,
            storeName: node.label,
            storeAddress: node.address || ''
          };
        });
      }
    },
    selectAllUserRanks: function selectAllUserRanks() {
      if (this.isAllUserRanksSelected) {
        this.userRankList = [];
      } else {
        this.userRankList = this.userRankOptions.map(function (rank) {
          return rank.id;
        });
      }
    },
    selectAllOrderScenes: function selectAllOrderScenes() {
      // 如果已经全选，则取消全选；否则全选
      if (this.isAllOrderScenesSelected) {
        this.formData.orderScenes = [];
      } else {
        this.formData.orderScenes = [1, 2, 3];
      }
    },
    initAwardPack: function initAwardPack() {
      var awards = [];
      for (var i = 0; i < 8; i++) {
        awards.push({
          enabled: true,
          awardType: 0,
          rate: 0,
          total: 0,
          num: 1,
          typeId: null,
          imgUrl: '',
          iconUrl: '',
          hitTimes: 0
        });
      }
      // 不冻结数组，保持可变性以支持v-model双向绑定
      this.formData.pack = awards;
    },
    handleDateChange: function handleDateChange(val) {
      if (val && val.length === 2) {
        this.formData.startTime = val[0];
        this.formData.endTime = val[1];
      } else {
        this.formData.startTime = '';
        this.formData.endTime = '';
      }
    },
    handleAwardTypeChange: function handleAwardTypeChange(index) {
      var item = this.formData.pack[index];
      if (item.awardType === 0 || item.awardType === 4) {
        item.typeId = null;
        item.num = 1;
      }
    },
    handleRateInput: function handleRateInput(index) {
      // 处理中奖率输入，确保是数字且在合理范围内
      var item = this.formData.pack[index];
      var value = parseFloat(item.rate);
      if (isNaN(value)) {
        value = 0;
      }
      var maxRate = this.maxRates[index];
      if (value > maxRate) {
        value = maxRate;
      }
      if (value < 0) {
        value = 0;
      }
      // 保留最多两位小数
      item.rate = Math.round(value * 100) / 100;
      // totalRate 是计算属性，会自动更新，不需要手动触发
    },
    handleValidate: function handleValidate() {
      var errors = [];

      // 基本信息
      if (!this.formData.title) {
        errors.push('请填写活动标题');
      }
      if (!this.formData.startTime || !this.formData.endTime) {
        errors.push('请选择活动时间');
      }

      // 资格条件
      if (this.formData.isCondition === 1) {
        // 订单活动时，消费金额必填
        if (this.formData.pos === 2) {
          if (this.formData.conditionConsume === undefined || this.formData.conditionConsume === null || this.formData.conditionConsume < 0) {
            errors.push('请填写消费金额');
          }
        }
        if (this.formData.conditionInvite === undefined || this.formData.conditionInvite === null) {
          errors.push('请填写邀请好友条件');
        }
      }
      if (errors.length > 0) {
        this.$message.error(errors.join('\n'));
        return false;
      }

      // 奖品资料校验
      var packErrors = [];
      var totalRate = 0;
      for (var i = 0; i < this.formData.pack.length; i++) {
        var item = this.formData.pack[i];

        // 中奖率
        if (item.rate < 0) {
          packErrors.push("\u5956\u9879".concat(i + 1, "\u7684\u4E2D\u5956\u7387\u4E0D\u80FD\u5C0F\u4E8E0"));
        }
        totalRate += parseFloat(item.rate) || 0;

        // 奖品类型
        if (item.awardType === 0 || item.awardType === 4) {
          // 谢谢或再来一次
        } else {
          // 其他类型需要检查
          if (!item.num || item.num <= 0) {
            packErrors.push("\u5956\u9879".concat(i + 1, "\u7684\u6570\u91CF\u5FC5\u987B\u5927\u4E8E0"));
          }
          if (item.awardType === 1 && !item.typeId) {
            packErrors.push("\u5956\u9879".concat(i + 1, "\u8BF7\u9009\u62E9\u4F18\u60E0\u5238"));
          }
          if (item.awardType === 3 && (!item.total || item.total <= 0)) {
            packErrors.push("\u5956\u9879".concat(i + 1, "\u5468\u8FB9\u5956\u54C1\u7684\u603B\u6570\u5FC5\u987B\u5927\u4E8E0"));
          }
        }
      }
      if (Math.abs(totalRate - 100) > 0.01) {
        this.$message.error("\u4E2D\u5956\u7387\u603B\u548C\u5E94\u4E3A100%\uFF0C\u5F53\u524D\u4E3A".concat(totalRate, "%"));
        return false;
      }
      if (packErrors.length > 0) {
        this.$message.error(packErrors.join('\n'));
        return false;
      }
      this.$message.success('校验通过');
      return true;
    },
    handleReset: function handleReset() {
      var _this9 = this;
      this.$confirm('确认重置表单吗？所有未保存的内容将丢失。', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(function () {
        _this9.initAwardPack();
        _this9.dateRange = [];
        _this9.userRankList = [1, 2, 3, 4, 5];
        // 重置启用状态
        _this9.limitEnabled = {
          totalNum: true,
          preMaxNum: true,
          preDayMaxNum: true
        };
        _this9.conditionEnabled = {
          preDayGive: true,
          conditionConsume: true,
          conditionInvite: true,
          inviteGiveTimes: true,
          goods: false,
          category: false,
          weworkGiveTimes: true
        };
        // 重置商品和分类
        _this9.selectedGoodsList = [];
        _this9.selectedCategoryList = [];
        // 重置订单场景（默认全选）
        _this9.formData.orderScenes = [1, 2, 3];
        // 重置门店选择
        _this9.storeCheckedKeys = [];
        _this9.selectedStoreList = [];
        _this9.storeSearchText = '';
        if (_this9.id) {
          _this9.loadFormData();
        } else {
          _this9.formData = {
            title: '',
            share_title: '',
            banner_url: '',
            bg_url: '',
            share_img_url: '',
            theme: {
              fg_color: '#98CAC1',
              bg_color: '#1A4D38',
              btn_color: '#FF6B6B',
              btn_gradient_color: '#FF8E8E',
              btn_text_color: '#FFFFFF'
            },
            pos: 1,
            enabled: 1,
            show_order: 0,
            start_time: '',
            end_time: '',
            user_type: 0,
            user_rank: null,
            daily_reset: 0,
            is_qwe: 0,
            total_num: 0,
            pre_max_num: 0,
            pre_day_max_num: 0,
            pre_day_num: 0,
            pre_day_give: 0,
            condition_consume: 0,
            consume_max_times: 0,
            order_real: 0,
            condition_invite: 0,
            invite_give_times: 0,
            order_scenes: [],
            wework_give_times: 0,
            invite_order_give_times: 0,
            invite_friend_order: 0,
            is_condition: 0,
            point: 0,
            rule: '',
            pack: []
          };
          _this9.initAwardPack();
        }
        _this9.$message.success('已重置');
      }).catch(function () {});
    },
    loadFormData: function () {
      var _loadFormData = (0, _asyncToGenerator2.default)(/*#__PURE__*/regeneratorRuntime.mark(function _callee9() {
        var _this0 = this;
        var response, data, _t8;
        return regeneratorRuntime.wrap(function (_context9) {
          while (1) switch (_context9.prev = _context9.next) {
            case 0:
              console.log('loadFormData 开始，id:', this.id);
              this.loading = true;
              _context9.prev = 1;
              _context9.next = 2;
              return (0, _lottery.getLotteryDetail)(this.id);
            case 2:
              response = _context9.sent;
              console.log('getLotteryDetail 响应:', response);
              if (!(response.code === 200 && response.data)) {
                _context9.next = 6;
                break;
              }
              data = response.data; // 应用基本数据（不包含资源配置）
              this.applyFormData(data);

              // 等待资源配置加载完成后缓存
              _context9.next = 3;
              return this.$nextTick();
            case 3:
              if (!(data.goodsIds && Array.isArray(data.goodsIds) && data.goodsIds.length > 0)) {
                _context9.next = 4;
                break;
              }
              _context9.next = 4;
              return new Promise(function (resolve) {
                var checkGoods = setInterval(function () {
                  if (_this0.selectedGoodsList && _this0.selectedGoodsList.length > 0) {
                    clearInterval(checkGoods);
                    resolve();
                  }
                }, 100);

                // 超时保护
                setTimeout(function () {
                  clearInterval(checkGoods);
                  resolve();
                }, 2000);
              });
            case 4:
              if (!(data.storeIds && Array.isArray(data.storeIds) && data.storeIds.length > 0)) {
                _context9.next = 5;
                break;
              }
              _context9.next = 5;
              return new Promise(function (resolve) {
                var checkStores = setInterval(function () {
                  if (_this0.selectedStoreList && _this0.selectedStoreList.length > 0) {
                    clearInterval(checkStores);
                    resolve();
                  }
                }, 100);

                // 超时保护
                setTimeout(function () {
                  clearInterval(checkStores);
                  resolve();
                }, 2000);
              });
            case 5:
              // 所有资源加载完成后，缓存数据
              this.cacheActivityData(data);
              _context9.next = 7;
              break;
            case 6:
              this.$message.error(response.message || '获取详情失败');
            case 7:
              _context9.next = 9;
              break;
            case 8:
              _context9.prev = 8;
              _t8 = _context9["catch"](1);
              console.error('loadFormData 异常:', _t8);
              this.$message.error('获取详情失败：' + _t8.message);
            case 9:
              _context9.prev = 9;
              console.log('loadFormData 结束，loading 设置为 false');
              this.loading = false;
              return _context9.finish(9);
            case 10:
            case "end":
              return _context9.stop();
          }
        }, _callee9, this, [[1, 8, 9, 10]]);
      }));
      function loadFormData() {
        return _loadFormData.apply(this, arguments);
      }
      return loadFormData;
    }(),
    // 缓存活动数据（包括资源配置）
    cacheActivityData: function cacheActivityData(data) {
      if (!this.sharedData) return;

      // 检查是否已经缓存过
      if (this.sharedData.activityDetails && this.sharedData.activityDetails[this.id]) {
        console.log('活动数据已缓存，跳过');
        return;
      }
      this.sharedData.activityDetails = this.sharedData.activityDetails || {};
      this.sharedData.activityDetails[this.id] = _objectSpread(_objectSpread({}, data), {}, {
        _cachedResources: {
          selectedGoodsList: this.selectedGoodsList || [],
          selectedStoreList: this.selectedStoreList || []
        }
      });
      console.log('活动数据已缓存，包含资源配置，商品数:', this.selectedGoodsList.length, '门店数:', this.selectedStoreList.length);
    },
    processCategoryTree: function processCategoryTree(tree) {
      var _this1 = this;
      if (!tree || !Array.isArray(tree)) return [];
      return tree.map(function (item) {
        // 跳过null元素
        if (!item) return null;
        var node = {
          id: item.id,
          label: item.categoryName || item.name || item.label,
          categoryName: item.categoryName || item.name || item.label
        };

        // 如果有子节点，递归处理
        if (item.children && item.children.length > 0) {
          node.children = _this1.processCategoryTree(item.children);
        }
        return node;
      }).filter(function (item) {
        return item !== null;
      }); // 过滤掉null元素
    },
    openGoodsSelector: function openGoodsSelector() {
      this.goodsSelectorVisible = true;
      this.queryGoodsList();
    },
    queryGoodsList: function () {
      var _queryGoodsList = (0, _asyncToGenerator2.default)(/*#__PURE__*/regeneratorRuntime.mark(function _callee0() {
        var loading, params, response, firstGoods, _t9;
        return regeneratorRuntime.wrap(function (_context0) {
          while (1) switch (_context0.prev = _context0.next) {
            case 0:
              loading = this.$loading({
                lock: true,
                text: '加载中...',
                spinner: 'el-icon-loading',
                background: 'rgba(0, 0, 0, 0.7)'
              });
              _context0.prev = 1;
              params = {
                page: this.goodsListQuery.page,
                limit: this.goodsListQuery.limit,
                keywords: this.goodsListQuery.keywords,
                goodsType: this.goodsListQuery.goodsType,
                status: this.goodsListQuery.status
              }; // 处理分类参数
              if (this.goodsListQuery.categories && this.goodsListQuery.categories.length > 0) {
                params.categoryFirstId = this.goodsListQuery.categories[0];
                params.categorySecondId = this.goodsListQuery.categories[1] || null;
              }
              _context0.next = 2;
              return (0, _goods.queryList)(params);
            case 2:
              response = _context0.sent;
              loading.close();
              console.log('商品列表返回数据:', response);

              // 接口可能直接返回records和total，或者包装在data里
              if (response) {
                this.goodsListData = response.records || [];
                this.goodsListTotal = response.total || 0;
                console.log('处理后的商品数据:', this.goodsListData);
                // 输出第一个商品的图片路径信息
                if (this.goodsListData.length > 0) {
                  firstGoods = this.goodsListData[0];
                  console.log('第一个商品图片信息:', {
                    goodsThumbnailUrl: firstGoods.goodsThumbnailUrl,
                    imagePrefix: this.imagePrefix,
                    fullUrl: this.getGoodsImageUrl(firstGoods.goodsThumbnailUrl)
                  });
                }
              } else {
                this.$message.error('查询商品列表失败');
              }
              _context0.next = 4;
              break;
            case 3:
              _context0.prev = 3;
              _t9 = _context0["catch"](1);
              loading.close();
              this.$message.error('查询商品列表失败：' + _t9.message);
            case 4:
            case "end":
              return _context0.stop();
          }
        }, _callee0, this, [[1, 3]]);
      }));
      function queryGoodsList() {
        return _queryGoodsList.apply(this, arguments);
      }
      return queryGoodsList;
    }(),
    handleGoodsPageChange: function handleGoodsPageChange(page) {
      this.goodsListQuery.page = page;
      this.queryGoodsList();
    },
    checkGoodsSelectable: function checkGoodsSelectable(row) {
      return !this.selectedGoodsList.some(function (item) {
        return item.id === row.id;
      });
    },
    handleGoodsSelectionChange: function handleGoodsSelectionChange(selection) {
      this.tempSelectedGoods = selection;
    },
    confirmGoodsSelection: function confirmGoodsSelection() {
      var _this10 = this;
      if (this.tempSelectedGoods && this.tempSelectedGoods.length > 0) {
        this.tempSelectedGoods.forEach(function (goods) {
          if (!_this10.selectedGoodsList.some(function (item) {
            return item.id === goods.id;
          })) {
            _this10.selectedGoodsList.push({
              id: goods.id,
              goodsName: goods.goodsName,
              goodsType: goods.goodsType,
              categoryFirstName: goods.categoryFirstName,
              categorySecondName: goods.categorySecondName
            });
          }
        });
      }
      this.goodsSelectorVisible = false;
      this.tempSelectedGoods = [];
    },
    removeGoods: function removeGoods(goodsId) {
      var index = this.selectedGoodsList.findIndex(function (item) {
        return item.id === goodsId;
      });
      if (index > -1) {
        this.selectedGoodsList.splice(index, 1);
      }
    },
    handleClearGoods: function handleClearGoods() {
      var _this11 = this;
      this.$confirm('确认清空所有已选择的商品吗？此操作不可恢复。', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(function () {
        _this11.selectedGoodsList = [];
        _this11.$message.success('已清空所有商品');
      }).catch(function () {});
    },
    openCategorySelector: function openCategorySelector() {
      var _this12 = this;
      this.categorySelectorVisible = true;
      // 使用nextTick确保DOM已渲染，再设置默认选中
      this.$nextTick(function () {
        var tree = _this12.$refs.categoryTree;
        if (tree) {
          // 只设置叶子节点（小类）的选中状态
          console.log('打开对话框，设置选中的小类:', _this12.selectedCategoryList);
          tree.setCheckedKeys(_this12.selectedCategoryList);
        }
      });
    },
    confirmCategorySelection: function confirmCategorySelection() {
      var tree = this.$refs.categoryTree;
      if (tree) {
        // 获取所有选中的节点（包括半选的父节点）
        var allCheckedKeys = tree.getCheckedKeys();
        var halfCheckedKeys = tree.getHalfCheckedKeys();
        console.log('确认选择 - 完全选中的节点:', allCheckedKeys);
        console.log('确认选择 - 半选中的父节点:', halfCheckedKeys);

        // 只保留叶子节点（小类）的ID
        var leafCategoryIds = this.getLeafCategoryIds(allCheckedKeys);
        console.log('过滤后的叶子节点（小类）ID:', leafCategoryIds);
        this.selectedCategoryList = leafCategoryIds;
      }
      this.categorySelectorVisible = false;
    },
    getLeafCategoryIds: function getLeafCategoryIds(nodeIds) {
      // 从树形结构中找出哪些是叶子节点（小类）
      var leafIds = [];
      var _findLeafIds = function findLeafIds(nodes) {
        if (!nodes || !Array.isArray(nodes)) return;
        nodes.forEach(function (node) {
          // 如果是叶子节点且被选中
          if ((!node.children || node.children.length === 0) && nodeIds.includes(node.id)) {
            leafIds.push(node.id);
          }
          // 递归查找子节点
          if (node.children && node.children.length > 0) {
            _findLeafIds(node.children);
          }
        });
      };
      _findLeafIds(this.categoryOptions);
      return leafIds;
    },
    removeCategory: function removeCategory(categoryId) {
      var index = this.selectedCategoryList.findIndex(function (id) {
        return id === categoryId;
      });
      if (index > -1) {
        this.selectedCategoryList.splice(index, 1);
      }
    },
    getGoodsImageUrl: function getGoodsImageUrl(url) {
      if (!url) return '';
      // 如果已经是完整URL（以http开头），直接返回
      if (url.startsWith('http://') || url.startsWith('https://')) {
        return url;
      }
      // 否则拼接前缀
      var prefix = this.imagePrefix.endsWith('/') ? this.imagePrefix : this.imagePrefix + '/';
      var path = url.startsWith('/') ? url.slice(1) : url;
      return prefix + path;
    },
    loadGoodsByIds: function () {
      var _loadGoodsByIds = (0, _asyncToGenerator2.default)(/*#__PURE__*/regeneratorRuntime.mark(function _callee1(goodsIds) {
        var batchSize, allGoods, _loop, i, goodsIdMap, _t0;
        return regeneratorRuntime.wrap(function (_context10) {
          while (1) switch (_context10.prev = _context10.next) {
            case 0:
              if (!(!goodsIds || goodsIds.length === 0)) {
                _context10.next = 1;
                break;
              }
              this.selectedGoodsList = [];
              return _context10.abrupt("return");
            case 1:
              _context10.prev = 1;
              // 批量查询，每批最多50个商品
              batchSize = 50;
              allGoods = [];
              _loop = /*#__PURE__*/regeneratorRuntime.mark(function _loop() {
                var batchIds, response, targetIds, batchGoods;
                return regeneratorRuntime.wrap(function (_context1) {
                  while (1) switch (_context1.prev = _context1.next) {
                    case 0:
                      batchIds = goodsIds.slice(i, i + batchSize).join(',');
                      _context1.next = 1;
                      return (0, _goods.queryList)({
                        goodsIds: batchIds,
                        page: 1,
                        limit: batchSize
                      });
                    case 1:
                      response = _context1.sent;
                      if (response && response.records && Array.isArray(response.records)) {
                        // 创建一个Set用于快速查找，确保只保留我们需要的商品
                        targetIds = new Set(goodsIds.map(function (id) {
                          return Number(id);
                        })); // 过滤出真正的目标商品，确保ID匹配且去重
                        batchGoods = response.records.filter(function (item) {
                          return targetIds.has(Number(item.id));
                        }).map(function (item) {
                          return {
                            id: Number(item.id),
                            goodsName: item.goodsName,
                            goodsType: item.goodsType,
                            categoryFirstName: item.categoryFirstName,
                            categorySecondName: item.categorySecondName
                          };
                        });
                        allGoods.push.apply(allGoods, (0, _toConsumableArray2.default)(batchGoods));
                      }
                    case 2:
                    case "end":
                      return _context1.stop();
                  }
                }, _loop);
              });
              i = 0;
            case 2:
              if (!(i < goodsIds.length)) {
                _context10.next = 4;
                break;
              }
              return _context10.delegateYield(_loop(), "t0", 3);
            case 3:
              i += batchSize;
              _context10.next = 2;
              break;
            case 4:
              // 按原始ID顺序排序，保持一致性
              goodsIdMap = new Map(allGoods.map(function (item) {
                return [item.id, item];
              }));
              this.selectedGoodsList = goodsIds.map(function (id) {
                return goodsIdMap.get(Number(id));
              }).filter(function (item) {
                return item !== undefined;
              });
              console.log("\u6210\u529F\u52A0\u8F7D ".concat(this.selectedGoodsList.length, "/").concat(goodsIds.length, " \u4E2A\u5546\u54C1"));
              _context10.next = 6;
              break;
            case 5:
              _context10.prev = 5;
              _t0 = _context10["catch"](1);
              console.error('加载商品信息失败:', _t0);
              this.selectedGoodsList = [];
            case 6:
            case "end":
              return _context10.stop();
          }
        }, _callee1, this, [[1, 5]]);
      }));
      function loadGoodsByIds(_x2) {
        return _loadGoodsByIds.apply(this, arguments);
      }
      return loadGoodsByIds;
    }(),
    // 加载选中门店的信息
    loadSelectedStoreInfo: function loadSelectedStoreInfo() {
      if (!this.storeCheckedKeys || this.storeCheckedKeys.length === 0) {
        this.selectedStoreList = [];
        return;
      }

      // 从树形数据中获取选中的门店信息
      var _getAllLeafNodes2 = function getAllLeafNodes(nodes, checkedIds) {
        var leafNodes = [];
        nodes.forEach(function (node) {
          if (node.children && node.children.length > 0) {
            leafNodes = leafNodes.concat(_getAllLeafNodes2(node.children, checkedIds));
          } else if (checkedIds.includes(node.storeId)) {
            leafNodes.push({
              id: node.storeId,
              storeName: node.label,
              storeAddress: node.address || ''
            });
          }
        });
        return leafNodes;
      };
      this.selectedStoreList = _getAllLeafNodes2(this.storeTreeData, this.storeCheckedKeys);
    },
    getMaxRate: function getMaxRate(index) {
      // 计算当前奖品可设置的最高中奖率
      // 规则：总和必须等于100%，所以当前最高 = 100 - 其他奖品的总和
      var usedRate = 0;
      for (var i = 0; i < this.formData.pack.length; i++) {
        if (i !== index) {
          usedRate += parseFloat(this.formData.pack[i].rate) || 0;
        }
      }
      var maxRate = Math.max(0, 100 - usedRate);
      return parseFloat(maxRate.toFixed(2));
    },
    handleSubmit: function handleSubmit() {
      var _this13 = this;
      if (!this.handleValidate()) {
        return;
      }
      this.submitLoading = true;
      try {
        // 处理抽奖次数限制：未启用传-1，启用传实际值
        var totalNum = this.limitEnabled.totalNum ? this.formData.totalNum : -1;
        var preMaxNum = this.limitEnabled.preMaxNum ? this.formData.preMaxNum : -1;
        var preDayMaxNum = this.limitEnabled.preDayMaxNum ? this.formData.preDayMaxNum : -1;

        // 处理资格条件：未启用传-1，启用传实际值
        var preDayGive = this.conditionEnabled.preDayGive ? this.formData.preDayGive : -1;
        var conditionConsume = this.conditionEnabled.conditionConsume ? this.formData.conditionConsume : -1;
        var conditionInvite = this.conditionEnabled.conditionInvite ? this.formData.conditionInvite : -1;
        var inviteGiveTimes = this.conditionEnabled.inviteGiveTimes ? this.formData.inviteGiveTimes : -1;
        var weworkGiveTimes = this.conditionEnabled.weworkGiveTimes ? this.formData.weworkGiveTimes : -1;

        // 处理商品ID列表和分类ID列表
        var goodsIds = this.conditionEnabled.goods ? this.selectedGoodsList.map(function (item) {
          return item.id;
        }) : [];
        var categoryIds = this.conditionEnabled.category ? this.selectedCategoryList : [];

        // 处理订单场景
        var orderScenes = this.formData.orderScenes && this.formData.orderScenes.length > 0 ? this.formData.orderScenes : [1, 2, 3];

        // 处理门店ID列表 - 仅在订单活动时提交
        var storeIds = this.formData.pos === 2 ? this.storeCheckedKeys : [];

        // 处理奖项包，将 hitTimes 转换为 hit_times
        var pack = this.formData.pack.map(function (item) {
          // 根据 awardType 生成 name 字段
          var name = '';
          if (item.awardType === 0) {
            name = '谢谢你';
          } else if (item.awardType === 1) {
            // 优惠券：从 bonusList 中找到对应的优惠券名称
            var bonus = _this13.bonusList.find(function (b) {
              return b.typeId === item.typeId;
            });
            name = bonus ? bonus.typeName : '';
          } else if (item.awardType === 2) {
            // 积分：数量+积分
            name = "".concat(item.num, "\u79EF\u5206");
          } else if (item.awardType === 3) {
            // 周边
            name = '周边';
          } else if (item.awardType === 4) {
            // 再来一次
            name = '再来一次';
          }
          return {
            enabled: item.enabled,
            awardType: item.awardType,
            rate: item.rate,
            total: item.total,
            num: item.num,
            typeId: item.typeId,
            imgUrl: item.imgUrl,
            iconUrl: item.iconUrl,
            hit_times: item.hitTimes,
            name: name
          };
        });

        // 将所有奖项的 hitTimes 拼接成字符串
        var hitTimesStr = this.formData.pack.map(function (item) {
          return item.hitTimes || 0;
        }).join(',');
        var submitData = _objectSpread(_objectSpread({}, this.formData), {}, {
          pos: this.formData.pos.toString(),
          userRank: this.userRankList.join(','),
          goodsIds: JSON.stringify(goodsIds),
          categoryIds: JSON.stringify(categoryIds),
          orderScenes: JSON.stringify(orderScenes),
          storeIds: JSON.stringify(storeIds),
          totalNum: totalNum,
          preMaxNum: preMaxNum,
          preDayMaxNum: preDayMaxNum,
          preDayGive: preDayGive,
          conditionConsume: conditionConsume,
          consumeMaxTimes: this.formData.consumeMaxTimes || 0,
          conditionInvite: conditionInvite,
          inviteGiveTimes: inviteGiveTimes,
          weworkGiveTimes: weworkGiveTimes,
          hitTimes: hitTimesStr,
          theme: JSON.stringify(this.formData.theme),
          pack: JSON.stringify(pack)
        });

        // 添加调试日志
        console.log('=== 保存数据检查 ===');
        console.log('limitEnabled:', JSON.stringify(this.limitEnabled));
        console.log('conditionEnabled:', JSON.stringify(this.conditionEnabled));
        console.log('formData:', {
          totalNum: this.formData.totalNum,
          preMaxNum: this.formData.preMaxNum,
          preDayMaxNum: this.formData.preDayMaxNum,
          preDayGive: this.formData.preDayGive,
          conditionConsume: this.formData.conditionConsume,
          conditionInvite: this.formData.conditionInvite,
          inviteGiveTimes: this.formData.inviteGiveTimes,
          weworkGiveTimes: this.formData.weworkGiveTimes
        });
        console.log('提交的值:', {
          totalNum: totalNum,
          preMaxNum: preMaxNum,
          preDayMaxNum: preDayMaxNum,
          preDayGive: preDayGive,
          conditionConsume: conditionConsume,
          conditionInvite: conditionInvite,
          inviteGiveTimes: inviteGiveTimes,
          weworkGiveTimes: weworkGiveTimes
        });
        console.log('==================');
        (0, _lottery.saveLottery)(submitData).then(function (response) {
          if (response.code === 200) {
            _this13.$message.success(_this13.id ? '编辑成功' : '添加成功');
            _this13.$emit('success');
          } else {
            _this13.$message.error(response.message || '保存失败');
          }
        }).catch(function (error) {
          _this13.$message.error('保存失败：' + error.message);
        }).finally(function () {
          _this13.submitLoading = false;
        });
      } catch (error) {
        this.$message.error('保存失败：' + error.message);
        this.submitLoading = false;
      }
    }
  }
};